import { PageName } from "@tm/insurance/analytics";
import { ErrorScreen, ErrorScreenProps } from "../ui-container/ErrorScreen";

export function withError(
  component: JSX.Element,
  error: ErrorScreenProps["error"],
  pageName: PageName,
  statusCode?: string
) {
  return error ? (
    <ErrorScreen
      error={error}
      pageName={pageName}
      trackError
      statusCode={statusCode}
    />
  ) : (
    component
  );
}
